<template>
  <component
    :is="$props.tag"
    :class="{
      [`b-grid-item--behavior-${$props.behavior}`]: $props.behavior,
      [`b-grid-item--column-${$props.column}`]: $props.column,
      [`b-grid-item--row-${$props.row}`]: $props.row,
      ['b-grid-item--responsive']: $state.isResponsive,
    }"
    class="b-grid-item"
  >
    <slot />
  </component>
</template>

<script setup>
import { shouldBeOneOf } from 'vue-prop-validation-helper';
import { reactive, computed, inject } from 'vue';
import { useScreen } from '@stores';
import { GridContainerKey } from './grid-container-key';

const $config = inject(GridContainerKey);
const $screen = useScreen();

const $props = defineProps({
  behavior: {
    type: String,
    default: null,
  },
  column: {
    type: [Number, String],
    default: 12,
  },
  row: {
    type: [Number, String],
    default: 1,
  },
  tag: {
    type: String,
    default: 'div',
    validator: shouldBeOneOf([
      'div',
      'article',
      'form',
      'button',
      'a',
      'router-link',
      'header',
      'footer',
      'span',
    ]),
  },
  responsive: {
    type: Boolean,
    default: false,
  },
});

// const name = 'BGridItem';

const $state = reactive({
  isResponsive: computed(() => $props.responsive || $config.responsive),
  gridConfig: computed(() => {
    if (!$state.isResponsive) return { column: $props.column, row: $props.row };

    let newColumnSize = $props.column;
    const halfParentColumns = Math.floor($config.columns / 2);

    if ($screen.isSizeDown('largeTablet')) {
      newColumnSize = $config.columns;
    } else if ($screen.isSizeDown('mediumDesktop')) {
      newColumnSize = $props.column >= halfParentColumns ? $config.columns : halfParentColumns;
    }

    return {
      column: newColumnSize,
      row: $props.row,
    };
  }),
});
</script>

<style lang="scss">
@import '@assets/styles/utils/breakpoints';

.b-grid-item {
  position: relative;

  grid-column: span var(--b-grid-item--column-number, v-bind('$state.gridConfig.column'));
  grid-row: span var(--b-grid-item--row-number, v-bind('$state.gridConfig.row'));
}

.b-grid-item--behavior-horizontal {
  align-items: flex-start;
  display: flex;
}

.b-grid-item--behavior-vertical {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}
</style>
